import { ResponsiveMapType } from './types'

export const twGap: ResponsiveMapType = {
  sm: {
    sm: '!ds-gap-grid-sm',
    md: '!ds-gap-grid-md',
    lg: '!ds-gap-grid-lg',
    none: '!ds-gap-grid-none'
  },
  md: {
    sm: 'md:!ds-gap-grid-sm',
    md: 'md:!ds-gap-grid-md',
    lg: 'md:!ds-gap-grid-lg',
    none: 'md:!ds-gap-grid-none'
  },
  lg: {
    sm: 'lg:!ds-gap-grid-sm',
    md: 'lg:!ds-gap-grid-md',
    lg: 'lg:!ds-gap-grid-lg',
    none: 'lg:!ds-gap-grid-none'
  },
  default: {
    sm: '!ds-gap-grid-sm',
    md: '!ds-gap-grid-md',
    lg: '!ds-gap-grid-lg',
    none: '!ds-gap-grid-none'
  }
}

export default twGap
